import React, { useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../Constants';

const FileUploader = ({ onUpload }) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('No file chosen');
  const [status, setStatus] = useState('');
  const [progress, setProgress] = useState(0);

  const handleChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile ? selectedFile.name : 'No file chosen');
    setProgress(0);
    setStatus('');
  };

  const handleUpload = async () => {
    if (!file) {
      setStatus('Please select a file first.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/media/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (event) => {
          const percent = Math.round((event.loaded * 100) / event.total);
          setProgress(percent);
        },
      });

      setStatus('✅ Upload successful!');
      onUpload(response.data.file);
      setFile(null);
      setFileName('No file chosen');
      setProgress(0);
    } catch (err) {
      console.error(err);
      setStatus('❌ Upload failed. Please try again.');
      setProgress(0);
    }
  };

  return (
    <div className="media-library">
      <h2>📁 Media Library</h2>
      <div className="file-upload d-flex align-items-center gap-3">
        <label htmlFor="fileInput" className="btn btn-outline-primary">
          Choose File
          <input
            type="file"
            id="fileInput"
            className="d-none"
            onChange={handleChange}
          />
        </label>
        <span className="text-muted">{fileName}</span>
        <button className="btn btn-primary" onClick={handleUpload}>
          Upload
        </button>
      </div>

      {progress > 0 && (
        <div className="progress mt-3">
          <div
            className="progress-bar bg-success progress-bar-striped progress-bar-animated"
            role="progressbar"
            style={{ width: `${progress}%` }}
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {progress}%
          </div>
        </div>
      )}

      {status && <p className="mt-3 text-muted">{status}</p>}
    </div>
  );
};

export default FileUploader;